import RecipeView from "./RecipeView";
import "./ProxyRpView.scss";

export default function ProxyRpView() {
    return (
        <div className="proxyRpWrapper flex justify-content-center align-items-center w-full">
            <div className="w-9/12 h-auto">
                <RecipeView />
            </div>
        </div>
    );
}
